import { Check, Circle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

type CheckTextProps = {
  checked?: boolean;
  children: React.ReactNode;
};
const CheckText = ({ children, checked }: CheckTextProps) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box
        sx={{
          width: "16px",
          height: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {checked ? (
          <Check sx={{ color: "primary.main", fontSize: "14px" }} />
        ) : (
          <Circle sx={{ fontSize: "2px" }} />
        )}
      </Box>
      <Typography
        variant="caption"
        sx={{
          color: checked ? "primary.main" : "text.secondary",
          fontSize: "12px",
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default CheckText;
